/**
 * ドロワーメニュー
 */
import {isIE} from '../helper/checkUserBrowser'
import {BREAKPOINT_PC} from '../define/define'

export default function() {

  document.addEventListener(`DOMContentLoaded`, ()=>{
    const menuButton_el = document.getElementById(`navBtn`)

    // ドロワーメニュー起動
    menuButton_el.addEventListener(`click`, function() {
      drawerMenu(this)
    })

    // 画面リサイズ時にPCの場合、メニューオープンクラスを解除する
    window.matchMedia(`(min-width: ${BREAKPOINT_PC}px)`).addListener(()=>{
      menuButton_el.classList.remove(`is-active`)
      document.getElementById(`jsScrollHeader`).classList.remove(`nav-open`)
    })
  })

}

/**
 * ドロワーメニューのopen/closeボタンクリック時関数
 * @param {*} elementHeader ドロワーメニューopen/closeボタンの要素
 */
function drawerMenu(elementHeader) {
  elementHeader.classList.toggle(`is-active`)

  //全体を囲む要素をid[#wrapper]で指定
  const elHeader = document.getElementById(`jsScrollHeader`)
  
  if (elHeader.classList.contains(`nav-open`)) {
    // メニューオープン中の場合、メニューを閉じる
    elHeader.classList.remove(`nav-open`)
  } else {
    // メニュークローズ中の場合、メニューをオープン
    elHeader.classList.add(`nav-open`)
  }
}

/**
 * fixed解除時に一番上へと移動してしまうので、open時に取得したスクロール位置まで移動させる
 * @param {*} positionY メニューオープン時のスクロール位置
 */
function cancelFixedBackground(positionY) {
  let elementBody = document.body
  elementBody.style.position = ``;
  elementBody.style.top = ``;
  let elementMain = document.getElementsByTagName(`main`);
  elementMain[0].style.width = ``;
  // fixed解除時に一番上へと移動してしまうので、open時に取得したスクロール位置まで移動させる。
  window.scrollTo(0, positionY); // fixedするときコメントアウトを取る
}

/**
 * 背景にposition: fixedを設定すると、一番上の位置で固定されてしまうので、現在のスクロール位置を取得して、それをcssで設定する。
 */
function fixedBackground() {
  // IE かどうかの判定で、利用するプロパティを変える
  const positionY = isIE() ? document.documentElement.scrollTop : document.scrollingElement.scrollTop
  let elementBody = document.body
  elementBody.style.position = `fixed`; // fixedするときコメントアウトを取る
  elementBody.style.top = `${-1 * positionY}px`; // fixedするときコメントアウトを取る
  let elementMain = document.getElementsByTagName(`main`)
  elementMain[0].style.width = `100vw`
}
